import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("athena_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.startsWith("/p/")) {
      localStorage.removeItem("athena_token");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function formatErr(detail) {
  if (detail == null) return "Si è verificato un errore.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fmtMin = (m) => {
  if (m == null) return "-";
  const h = Math.floor(m / 60);
  const mm = Math.round(m % 60);
  return h > 0 ? `${h}h ${mm}m` : `${mm}m`;
};

const hm = (t) => (t && t.length === 5 && t[0] === "0" ? t.slice(1) : t);
export const fmtLessonWhen = (l) => {
  if (!l?.date) return "—";
  const d = new Date(`${l.date}T00:00:00`).toLocaleDateString("it-IT");
  if (!l.start_time) return d;
  return `${d} h. ${hm(l.start_time)}${l.end_time ? ` / ${hm(l.end_time)}` : ""}`;
};

export const STATUS_LABELS = {
  presente: "Presente",
  parziale: "Presenza parziale",
  assente: "Assente",
  da_verificare: "Da verificare",
  giustificato: "Giustificato",
};

export const statusBadgeClass = (s) =>
  ({
    presente: "bg-emerald-50 text-emerald-800 border-emerald-200",
    parziale: "bg-amber-50 text-amber-800 border-amber-200",
    assente: "bg-rose-50 text-rose-800 border-rose-200",
    da_verificare: "bg-orange-50 text-orange-800 border-orange-200",
    giustificato: "bg-sky-50 text-sky-800 border-sky-200",
  }[s] || "bg-slate-100 text-slate-700 border-slate-200");

export const flagDot = (f) =>
  ({
    green: "bg-emerald-500",
    yellow: "bg-amber-500",
    orange: "bg-orange-500",
    red: "bg-rose-500",
    gray: "bg-slate-400",
  }[f] || "bg-slate-400");

export const flagLabel = (f) =>
  ({ green: "Regolare", yellow: "Attenzione", orange: "Rischio", red: "Rischio · limite superato", gray: "N/D" }[f] || "N/D");

export const TREND_LABELS = { regolare: "Regolare", attenzione: "Attenzione", rischio: "Rischio", nd: "N/D" };

export const fmtDateTime = (v) => {
  if (!v) return "—";
  const d = new Date(v.includes("T") ? v : `${v}T00:00:00`);
  if (Number.isNaN(d.getTime())) return v;
  return v.includes("T")
    ? d.toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" })
    : d.toLocaleDateString("it-IT");
};
